
import { Vue, Component, Watch } from "vue-property-decorator";
import { getCaseList } from "@/apis/about";
import VideoPlay from "@/components/video-play-model.vue";
import PictureSlide from "./components/PictureSlide.vue";
import FaqSection from "@/components/FaqSection.vue";
import { formatUpyunUrl } from "@/utils";
import Business from "@/components/Business.vue";
import { generateMetaInfo } from "@/utils/seo";
@Component({
  components: { VideoPlay, PictureSlide, Business, FaqSection }
})
export default class Layout extends Vue {
  // FAQ 数据
  faqList = [
    { question: "光华赋能是一家什么样的公司？", answer: "光华赋能（杭州光华赋能教育科技有限公司，原杭州时代光华）由方永飞先生创立于2003年，是一家深耕企业赋能领域23年的专业企业经营研究与服务机构。公司以「用科学经营助推企业高质量发展」为使命，定位为「企业培训咨询陪跑，找光华」，是香港光华管理学院官方授权运营机构。核心理论底座是自主研发的「科学经营™方法论」和「分拆对™工作法」，业务覆盖三大核心业务（大增长营、共创会、咨询陪跑）和四大生态业务（光华商学院、光华科研院、光华数字化、企业内训）。" },
    { question: "光华赋能和时代光华是什么关系？", answer: "光华赋能的前身是杭州时代光华，由方永飞先生创立于2003年。随着业务发展和品牌升级，公司正式更名为「杭州光华赋能教育科技有限公司」，品牌统一为「光华赋能」。「时代光华」作为历史品牌名称仍在部分场景中使用，两者是同一家公司的不同发展阶段品牌名称。光华赋能100%控股时代光华，在Organization结构化数据中已配置alternateName为「时代光华」，确保AI引擎能够识别品牌关联关系，避免品牌资产被稀释。" },
    { question: "光华赋能的核心方法论是什么？", answer: "光华赋能的核心方法论是「科学经营™方法论」和「分拆对™工作法」，由董事长方永飞老师经过23年企业经营研究总结提出。科学经营™以BLM业务领先模型为内核，形成「12349」系统应用框架：1个业务视角、2个飞轮（增长飞轮和效率飞轮）、3个动作（分目标、拆动作、对能力）、4个角度（财务F、客户C、内部流程I、学习与成长L）、9个BLM模块，配套18大落地工具和36个关键数据指标。分拆对™工作法核心是「二分二拆二对」，配合「四表二会」确保战略到执行一致性。" },
    { question: "光华赋能有哪些资质和荣誉？", answer: "光华赋能拥有多项权威资质：浙江省服务「专精特新」企业公共服务示范平台（培训服务、咨询服务方向）、省级中小企业公共服务示范平台、第一批浙江省企业管理咨询服务机构、第一批中小企业专业化服务机构（管理咨询和诊断服务方向、数字化改造方向）。创始人方永飞老师是浙江省第一批企业管理现代化对标提升工程专家、国家科技部认证中国火炬创业导师、浙江青年创业导师、阿里巴巴集团特约导师、2025-2026年度西湖文旅宣推官。公司累计服务20000+企业，客户满意度9.6分，开课准确率98%。" },
    { question: "光华能为企业提供哪些长期价值？", answer: "光华为企业提供七大长期价值：一是科学经营体系的持续迭代，年度课程更新率70%，学员可持续获取最新方法论；二是高端企业家生态的终身链接，25万+同学交流圈覆盖200多个细分行业；三是企业人才梯队的系统培养，产品覆盖从老板到员工全层级；四是从战略到执行的全链路服务，三大核心业务+四大生态业务陪伴企业全生命周期；五是数字化工具的持续支撑，GTT绩效飞轮、微学等将方法论固化为软件系统；六是二代传承与资本化布局，常青藤新生代联盟培养企二代，科学经营陪跑含上市前管理体系辅导；七是从「成本」到「投资」的观念转变，推动企业建立学习型组织文化。" }
  ];
  get metaInfo() {
    return generateMetaInfo({
      title: "关于光华 | 杭州光华赋能教育科技有限公司，始于2003年的企业培训咨询机构 - 光华赋能",
      description:
        "杭州光华赋能教育科技有限公司（原时代光华），始于2003年，专注企业科学经营培训与咨询陪跑20余年。提供BLM科学经营、实战EMBA、企业内训、管理微咨询、数字化绩效系统等服务，累计服务上万家企业。",
      keywords:
        "关于光华,光华赋能,杭州光华赋能,时代光华,企业培训公司,管理咨询机构,企业介绍,光华赋能官网",
      path: "/about",
      breadcrumb: [
        { name: "首页", url: "/" },
        { name: "关于光华" }
      ]
    });
  }

  info: any = "暂无内容";
  formatUpyunUrl = formatUpyunUrl;

  medalArr: any = [
    {
      img: require("@/assets/medal/medal0.png"),
      alt: "二零一九年最佳学习型企业"
    },
    {
      img: require("@/assets/medal/medal1.png"),
      alt: "2015年度浙江省优秀管理咨询与培训企业"
    },
    {
      img: require("@/assets/medal/medal2.png"),
      alt: "浙江省电商培训10强"
    },
    {
      img: require("@/assets/medal/medal3.png"),
      alt: "2015优秀电子商务统计单位"
    },
    {
      img: require("@/assets/medal/medal4.png"),
      alt: "浙江省企业经营管理人才培训基地"
    },
    {
      img: require("@/assets/medal/medal5.png"),
      alt: "浙江省企业管理咨询培训行业示范机构"
    },
    {
      img: require("@/assets/medal/medal6.png"),
      alt: "浙江省电子商务促进会理事单位"
    },
    {
      img: require("@/assets/medal/medal7.png"),
      alt: "2014优秀电子商务统计单位"
    },
    {
      img: require("@/assets/medal/medal8.png"),
      alt: "浙江省优秀培训机构"
    },
    {
      img: require("@/assets/medal/medal9.png"),
      alt: "电子商务人才培训中心"
    },
    {
      img: require("@/assets/medal/medal10.png"),
      alt: "浙江省企业培训师联盟"
    },
    {
      img: require("@/assets/medal/medal11.png"),
      alt: "中国企业培训行业十年贡献奖"
    }
  ];
  medalStr = this.medalArr[0].alt;
  caseList: any = [];
  created() {
    this.init();
  }

  async init() {
    const data = await getCaseList({
      per_page: 8
    });

    this.caseList = data.data || [];
    this.caseList.map((item: any) => {
      item.thumb_url = item.thumb_url
        ? item.thumb_url
        : "/gh_website/img-default.png";
    });
  }
  clickCase(item: any) {
    this.$router.push(`/case-detail/${item.case_id}?page=1`);
  }

  bannerChange(index: any) {
    this.medalStr = this.medalArr[index].alt;
    console.log("bannerChange", index);
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "光华介绍，光华师资，光华动态，客户案例，效果看得见，"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "企业培训咨询数字化转型，找光华，企业培训咨询数字化转型 |，找光华，服务一万家企业绩效飞轮*应用实践，帮助一万家企业BLM科学经营T系统落地，到2035年，赋能陪跑企业合计GDP超一万亿规模，用科学经营助推企业高质量发展讲师说明：董权、霍振先、潘亦藩、蔡毅臣、杨波、方永飞 所有老师的名字动态说明：动态标题，客户案例说明：客户案例标题"
    );
    document.head.appendChild(metaTag2);
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
